import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IBrandCartV2) {
    (function(State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        /**
     * The total of the brand cart is above brand's minimum but below maximum.
     */ State["READY_FOR_CHECKOUT"] = "READY_FOR_CHECKOUT";
        /**
     * The total of the brand cart is above brand's maximum.
     */ State["ABOVE_MAXIMUM"] = "ABOVE_MAXIMUM";
        /**
     * The total of the brand cart is below brand's minimum.
     */ State["BELOW_MINIMUM"] = "BELOW_MINIMUM";
        /**
     * The brand is on vacation.
     */ State["ON_VACATION"] = "ON_VACATION";
        /**
     * The brand cart is saved for later (and thus not checked out as a part of the overall cart).
     */ State["SAVED_FOR_LATER"] = "SAVED_FOR_LATER";
    })(IBrandCartV2.State || (IBrandCartV2.State = {}));
    (function(FreeNudgeState) {
        FreeNudgeState["FREE_NUDGE_STATE_UNKNOWN"] = "FREE_NUDGE_STATE_UNKNOWN";
        FreeNudgeState["RETAILER_FIRST_ORDER_NUDGE"] = "RETAILER_FIRST_ORDER_NUDGE";
        FreeNudgeState["BRAND_FIRST_ORDER_NUDGE"] = "BRAND_FIRST_ORDER_NUDGE";
        FreeNudgeState["NO_NUDGE"] = "NO_NUDGE";
    })(IBrandCartV2.FreeNudgeState || (IBrandCartV2.FreeNudgeState = {}));
    (function(FaireProtectionStatus) {
        FaireProtectionStatus["FAIRE_PROTECTION_STATUS_UNKNOWN"] = "FAIRE_PROTECTION_STATUS_UNKNOWN";
    })(IBrandCartV2.FaireProtectionStatus || (IBrandCartV2.FaireProtectionStatus = {}));
    (function(IBrandCartReview) {
        IBrandCartReview.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IBrandCartV2.IBrandCartReview || (IBrandCartV2.IBrandCartReview = {}));
    (function(ReviewStatus) {
        ReviewStatus["REVIEW_STATUS_UNKNOWN"] = "REVIEW_STATUS_UNKNOWN";
        ReviewStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    })(IBrandCartV2.ReviewStatus || (IBrandCartV2.ReviewStatus = {}));
    IBrandCartV2.build = function(partial) {
        return _object_spread({
            cart_items: {},
            brand_promos: [],
            disclaimers: [],
            shipment_groups: [],
            cart_items_tooltips: {}
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBrandCartV2 || (IBrandCartV2 = {}));
export var IBrandCartV2;
